import React from 'react';
import ReactApexChart from 'react-apexcharts';
import '../HorizontalBarChart/HorizontalBarChart.css';

const HorizontalBarChart = () => {
  const values = ['$4.35', '$28.88', '$61.87', '$123.64', '$69.94', '$174.91', '$100.97', '$148.74'];

  // Convert values to numbers
  const numericValues = values.map(val => parseFloat(val.replace('$', '')));

  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false, // Disable the toolbar
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        borderRadiusApplication: 'end',
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        // Use numericValues array to display data
        return `$${numericValues[opts.dataPointIndex].toFixed(2)}` || '';
      },
      style: {
        colors: ['#000'],
      },
      offsetX: 10,
    },
    xaxis: {
      categories: [
        'Net Current Assets Value',
        'Tangibal Book',
        'Projected FCF',
        'Median PS Value',
        'Graham Number',
        'Peter Lynch Value',
        'DCF (FCF Based)',
        'DCF (Earning Based)',
      ],
    },
    colors: ['#d85140'], // Set the fill color for the bars
  };
  

  const series = [
    {
      data: numericValues,
    },
  ];

  return (
    <div className="horizontal-container">
      <h2>Key Financial Valuation Metrics</h2>
      <div id="chart">
        <ReactApexChart options={chartOptions} series={series} type="bar" height={350} />
      </div>
    </div>
  );
};

export default HorizontalBarChart;
